import { AppDispatch, RootState, ThunkDispatchType } from '../types/redux'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'

export const useAppDispatch = () => useDispatch<AppDispatch>()

export const useAppThunkDispatch = () => useDispatch<ThunkDispatchType>()

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
